import api from "../helpers/axios";

class AgentService {
    async getAllAgents(includeInactive = true) {
        try {
            const response = await api.get(`/admin/agents?include_inactive=${includeInactive}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching agents:", error);
            throw error;
        }
    }

    async updateAgent(agentId, payload) {
        try {
            const response = await api.put(`/admin/agents/${agentId}`, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating agent:", error);
            throw error;
        }
    }
}

export default new AgentService();
